import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://wtufyseimadtznnmcrbm.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind0dWZ5c2VpbWFkdHpubm1jcmJtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ1NzczNDAsImV4cCI6MjA3MDE1MzM0MH0.mPZqL9YUwcpVHB2CpC4Ug6mhM0SbVR-BR4UJ36pQCBE';

// Check if the configuration is valid
if (!supabaseUrl || supabaseUrl === 'https://your-project-url.supabase.co' || !supabaseKey || supabaseKey === 'your-anon-key') {
  console.error('Invalid Supabase configuration');
}

// Initialize Supabase client with more options for better real-time support
export const supabase = createClient(supabaseUrl, supabaseKey, {
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  db: {
    schema: 'public'
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

// Initialize realtime channels
supabase.realtime.setAuth(supabaseKey);